import { StudioSystemType } from 'types/global'
import {
  clearPZSEAttachmentSpacingError,
  clearPZSEMaxSpanFailureWarning,
  clearPZSEMaxSpanStaleWarning,
  syncPZSEMaxSpanFailureWarning,
  syncPZSEMaxSpanStaleWarning,
  validatePZSEAttachmentSpacing,
} from './PZSE'

/** Cleared by `clear()` in calculate.ts alongside other custom plugin error keys. */
export function clearSnapnrackUltraRailPluginErrors(systemUuid: string): void {
  clearPZSEMaxSpanFailureWarning(systemUuid)
  clearPZSEMaxSpanStaleWarning(systemUuid)
  clearPZSEAttachmentSpacingError(systemUuid)
}

export function snapnrackUltraRailAfterCalculate(system: StudioSystemType): void {
  syncPZSEMaxSpanFailureWarning(system)
  syncPZSEMaxSpanStaleWarning(system)
  const attachmentSpacing = system.integration_json?.snapnrackUltraRail?.attachmentSpacingInches
  if (attachmentSpacing != null) {
    validatePZSEAttachmentSpacing(system.uuid, Number(attachmentSpacing))
  }
}
